import { useState } from "react";
const useUUID = (uuidProps)=>{
    const { idOverride, prefix } = uuidProps ?? {};
    const [uuid] = useState(()=>crypto.randomUUID());
    if (idOverride) return idOverride;
    const id = `${prefix ?? 'id'}-${uuid}`.replaceAll(' ', '-');
    return id;
};
export { useUUID };
